/**
 * CustomSwitch
 * 
 * @Author: Focci
 * @Date: 2023-07-21 15:14:50
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-21 15:14:50
 */

'use client'

// import PropTypes from 'prop-types'
import Switch from '@mui/material/Switch'

export default function CustomSwitch({
  small = false,
  color,
  ...props
}) {
  return (
    <Switch
      inputProps={{ 'aria-label': 'Show Map' }}
      sx={(theme) => ({
        '&.MuiSwitch-root': {
          padding: 0,
          borderRadius: '99999px',
          height: small ? '.9rem' : '1.5rem',
          width: small ? '1.5rem' : '2.5rem',
        },
        '& .MuiSwitch-switchBase': {
          padding: '.15rem'
        },
        '& .MuiSwitch-thumb': {
          width: small ? '.6rem' : '1.2rem',
          height: small ? '.6rem' : '1.2rem',
        },
        '& .MuiSwitch-switchBase:not(.Mui-checked) ~ .MuiSwitch-track': {
          opacity: 0.2,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
          transform: small ? 'translateX(.6rem)' : 'translateX(1rem)',
        },
        '& .MuiSwitch-switchBase.Mui-checked ~ .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: color || theme.palette.primary.main
        },
        '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
          backgroundColor: '#fff'
        },
      })}
      {...props}
    />
  )
}

// CustomSwitch.propTypes = {
//   className: PropTypes.string,
// }
